import React from 'react'

const PoliciesFlat = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M6.4 3.6 H15.4 L17.6 5.8 V19.4 A1 1 0 0 1 16.6 20.4 H6.4 A1 1 0 0 1 5.4 19.4 V4.6 A1 1 0 0 1 6.4 3.6 Z" />
      <path d="M15.2 3.6 V5.6 A1 1 0 0 0 16.2 6.6 H17.6" />
      <path d="M15.7 12.1 L16.75 13.15 L19 10.9" />
      <path d="M8.1 8.3 H12.9" />
      <path d="M8.1 11.1 H12.4" />
      <path d="M8.1 16.6 H12.9" />
    </g>
  </svg>
)

export default PoliciesFlat
